<template>
  <div class="uk-grid uk-grid-small" data-uk-grid>
    <div class="uk-width-1-1">
      <button class="uk-button uk-width-1-1 uk-button-primary" @click.prevent="openModal">
        Preisberechnung Import CH öffnen
      </button>
    </div>
    <div ref="modal" data-uk-modal="bg-close: false">
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header">
          <div class="uk-modal-title">
            <div class="uk-h4 uk-margin-remove">Preisberechnung Schweizer Franken</div>
          </div>
        </div>
        <div class="uk-modal-body">
          <div class="uk-grid uk-grid-small" data-uk-grid>
            <div class="uk-width-1-1">
              <p class="uk-text-bold">Fahrzeug: {{ vehicle }}</p>
              <div class="uk-margin">
                <label>Kaufpreis netto exkl. MwSt.</label>
                <input type="text" class="uk-input" v-model="saleprice">
              </div>
              <div class="uk-margin">
                <label>Transportkosten in EUR</label>
                <input type="text" class="uk-input" v-model="fixedTransportEUR">
              </div>
            </div>
            <div class="uk-width-1-1 uk-position-relative">
              <div class="uk-overlay-default uk-position-cover" v-if="sending">
                <div class="uk-flex uk-flex-center uk-flex-middle uk-padding-large">
                  <div data-uk-spinner="ratio: 1.5"></div>
                </div>
              </div>
              <table class="uk-table uk-table-small uk-table-striped uk-text-small">
                <tbody>
                  <tr>
                    <td>Fahrzeugpreis Netto exkl. MwSt.</td>
                    <td class="uk-text-right">{{ formattedPrice(saleprice, 'EUR', 0) }}</td>
                    <td class="uk-text-right">{{ formattedPrice(calculation.baseprice, 'CHF') }}</td>
                  </tr>
                  <tr>
                    <td>Automobilsteuer CH</td>
                    <td class="uk-text-right">4,0%</td>
                    <td class="uk-text-right">{{ formattedPrice(calculation.vehicleVatChf, 'CHF') }}</td>
                  </tr>
                  <tr>
                    <td>Importsteuer / Gewichtszoll</td>
                    <td class="uk-text-right">1,0%</td>
                    <td class="uk-text-right"> {{ formattedPrice(calculation.importVat, 'CHF') }}</td>
                  </tr>
                  <tr>
                    <td>Mehrwertsteuer CH</td>
                    <td class="uk-text-right">8,1%</td>
                    <td class="uk-text-right"> {{ formattedPrice(calculation.vatChf, 'CHF') }}</td>
                  </tr>
                  <tr>
                    <td>Zollagentur (pauschal)</td>
                    <td class="uk-text-right"></td>
                    <td class="uk-text-right"> {{ formattedPrice(fixedDuty, 'CHF') }}</td>
                  </tr>
                  <tr>
                    <td>Transport</td>
                    <td class="uk-text-right">{{ formattedPrice(fixedTransportEUR, 'EUR') }}</td>
                    <td class="uk-text-right"> {{ formattedPrice(calculation.fixedTransportChf, 'CHF') }}</td>
                  </tr>
                  <tr>
                    <td>Vorführen MFK</td>
                    <td class="uk-text-right"></td>
                    <td class="uk-text-right"> {{ formattedPrice(mfk, 'CHF') }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="uk-margin">
                <span>Preis CHF inkl. Import Kosten:</span>
                <span class="uk-text-bold">{{ formattedPrice(calculation.total, 'CHF', 0) }} (brutto)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { debounce } from 'lodash'
export default {
  props: {
    vehicle: {
      type: String,
      required: true
    },
    price: {
      required: true
    },
  },
  components: {
    vSelect,
    VueSlider
  },
  data() {
    return {
      exchangeRateChf: 1,
      calculation: {
        baseprice: 0,
        vehicleVatChf: 0,
        importVat: 0,
        vatChf: 0,
        fixedTransportChf: 0,
      },
      vehicleVatChf: 4.00,
      importVat: 1.00,
      vatChf: 8.1,
      fixedDuty: 30,
      fixedTransportEUR: 500,
      mfk: 100,
      saleprice: 0,
      sending: false
    }
  },
  mounted() {
    this.saleprice = this.price
  },
  watch: {
    saleprice() {
      if(this.saleprice >= 0) {
        this.sending = true
        this.getRate()
      }
    },
    fixedTransportEUR() {
      if(this.saleprice >= 0) {
        this.sending = true
        this.getRate()
      }
    },
  },
  methods: {
    getRate: debounce(function () {
      axios.get('/wp-json/ansolution/v1/webkfz/exchange-rate', {
        params: { currency: 'CHF' }
      }).then(response => {
        const basePriceChf = this.saleprice * response.data;
        const importPrice1 = basePriceChf + (basePriceChf * (this.vehicleVatChf / 100)) + (basePriceChf * (this.importVat / 100));
        const importPrice2 = (importPrice1 * this.vatChf / 100) + importPrice1;
        this.calculation = {
          baseprice: basePriceChf,
          vehicleVatChf: basePriceChf * (this.vehicleVatChf / 100),
          importVat: basePriceChf * (this.importVat / 100),
          vatChf: importPrice1 * (this.vatChf / 100),
          fixedDuty: this.fixedDuty,
          fixedTransportChf: this.fixedTransportEUR * response.data,
          total: Math.floor(importPrice2 + this.fixedDuty + (this.fixedTransportEUR * response.data) + this.mfk)
        }
        this.sending = false
      })
    }, 1000),
    openModal() {
      UIkit.modal(this.$refs.modal).show();
      this.getRate()
    },
    formattedPrice(value, currency, minimumFractionDigits = 2) {
      const nf = new Intl.NumberFormat(['de-DE'], {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: minimumFractionDigits
      });

      return nf.format(value)
    },
  }
}
</script>